module.exports = __webpack_public_path__ + "static/media/03n.aee4a6ec.png";